/// <reference types="@capacitor/cli" />
/**
 * @since 8.0.0
 */
export var Style;
(function (Style) {
    /**
     * Light icons on a dark background.
     *
     * @since 8.0.0
     */
    Style["Dark"] = "DARK";
    /**
     * Resolved from the current device appearance.
     *
     * @since 8.0.0
     */
    Style["Default"] = "DEFAULT";
    /**
     * Dark icons on a light background.
     *
     * @since 8.0.0
     */
    Style["Light"] = "LIGHT";
})(Style || (Style = {}));
//# sourceMappingURL=definitions.js.map